const CONTENT_STRINGS = {};

//Labels
CONTENT_STRINGS.ADD_ANOTHER = 'Add another';
CONTENT_STRINGS.REMOVE = 'Remove';
CONTENT_STRINGS.SUBMIT_APPLICATION = 'Submit Application';
CONTENT_STRINGS.CANCEL = 'Cancel';
CONTENT_STRINGS.SAVE = 'Save';
CONTENT_STRINGS.REQUEST_APPROVAL = 'Request Approval';
CONTENT_STRINGS.YES = 'Yes';
CONTENT_STRINGS.NO = 'No';
CONTENT_STRINGS.AWAITING_APPROVAL = 'Awaiting Approval';
CONTENT_STRINGS.SAVE_PROGRESS = 'Save Progress';
CONTENT_STRINGS.CONFIRMATION = 'Confirmation';
CONTENT_STRINGS.CASE_TYPE = 'Case Type';
CONTENT_STRINGS.SUB_CASE_TYPE = 'Sub Case Type';
CONTENT_STRINGS.VIEW = 'View';
CONTENT_STRINGS.DATE_PLACEHOLDER = 'DD/MM/YYYY';
CONTENT_STRINGS.FILES_ALREADY_ATTACHED = 'Files Already Attached.';
CONTENT_STRINGS.CREATE_NEW_APPLICATION = 'Create New Application';
CONTENT_STRINGS.ACTIONS = 'Actions';
CONTENT_STRINGS.ADD_COMMENT = 'Please add your comment';
CONTENT_STRINGS.ADD_ATTACHMENT = 'Add Attachment';
CONTENT_STRINGS.ARE_YOU_SURE = 'Are you sure?';
CONTENT_STRINGS.ARAG = 'ARAG';
CONTENT_STRINGS.ARAG_AND_MEDICAL_EXPERTS = 'ARAG and Medical Experts';
CONTENT_STRINGS.SUBMIT = 'Submit';
CONTENT_STRINGS.VISIBLE_TO_ALL = 'Visible to all';
CONTENT_STRINGS.VISIBLE_TO_ARAG_AND_MEDICAL_EXPERT = 'Visible to ARAG and Medical Expert';
CONTENT_STRINGS.VISIBLE_TO_ARAG = 'Visible to ARAG';
CONTENT_STRINGS.UPLOAD_FILE = 'Upload File';
CONTENT_STRINGS.UPLOAD_FILE_UPDATE_FORM = 'Upload File(s) (Max Size: 10MB)';
CONTENT_STRINGS.NO_CHANGES = 'No Changes';
CONTENT_STRINGS.REQUEST_UPDATE = 'Request Update';
CONTENT_STRINGS.PREVIOUS_UPDATES = 'Previous Updates';
CONTENT_STRINGS.SEE_MORE = 'See more';
CONTENT_STRINGS.DOWNLOAD = 'Download';
CONTENT_STRINGS.PREVIEW = 'Preview';
CONTENT_STRINGS.CLOSE = 'Close';
CONTENT_STRINGS.DELETE = 'Delete';
CONTENT_STRINGS.SAVE_AND_GO_LIVE = 'Save and go live';
CONTENT_STRINGS.EDIT = 'Edit';
CONTENT_STRINGS.UPDATE_PREMIUM_SETTING = 'Update Premium Setting';
CONTENT_STRINGS.CREATE_PREMIUM_SETTING = 'Create Premium Setting';
CONTENT_STRINGS.EDIT_PREMIUM_SETTING = 'Edit Premium Setting';
CONTENT_STRINGS.NEXT_STEP = 'Next Step';
CONTENT_STRINGS.APPLICATION_PREMIUM_SETTINGS = 'Application Premium Settings';
CONTENT_STRINGS.VALID_FROM = 'Valid from';
CONTENT_STRINGS.VALID_UNTIL = 'Valid until';
CONTENT_STRINGS.LIMIT_OF_INDEMNITY = 'Limit of Indemnity';
CONTENT_STRINGS.NOTES = 'Notes';
CONTENT_STRINGS.COMMENTS = 'Comments';
CONTENT_STRINGS.ENDORSEMENTS = 'Endorsements';
CONTENT_STRINGS.RECOVERABLE_RATE = 'Recoverable Rate';
CONTENT_STRINGS.COVERAGE_TYPES = 'Coverage Types';
CONTENT_STRINGS.DEDUCTIBLES = 'Deductibles';
CONTENT_STRINGS.ADD_NEW_COMMISSION = 'Add New Commission';
CONTENT_STRINGS.AGENT = 'Agent';
CONTENT_STRINGS.TYPE_AT_LEAST_3_LETTERS = 'Type at least 3 letters';
CONTENT_STRINGS.NO_AGENTS_FOUND = 'No Agents found';
CONTENT_STRINGS.STAGE_A_TITLE = 'Stage A: From CFA date to 3 years after Date of Incident minus 1 day';
CONTENT_STRINGS.STAGE_B_TITLE = 'Stage B: From 3 to 5 years after Date of Incident';
CONTENT_STRINGS.STAGE_C_TITLE = 'Stage C: From 5 years after Date of Incident onward';
CONTENT_STRINGS.BACK_TO = 'Back to ';
CONTENT_STRINGS.WORK_SOURCE = 'Work source';
CONTENT_STRINGS.SELECTED_SUB_CASE_TYPE = 'Selected Sub Case Type';
CONTENT_STRINGS.NON_RECOVERABLE = 'Non Recoverable';
CONTENT_STRINGS.UNDERWRITER_RATE = 'Underwriter Rate';
CONTENT_STRINGS.UNDERWRITER_RATE_PERCENTAGE = 'Underwriter Rate Percentage';
CONTENT_STRINGS.COMMISSION = 'Commission';
CONTENT_STRINGS.AVERAGE_EXPECTED_PREMIUM = 'Average Expected Premium';
CONTENT_STRINGS.PREMIUM = 'Premium';
CONTENT_STRINGS.CLINICAL_NEGLIGENCE = 'Clinical Negligence';
CONTENT_STRINGS.DAMAGES = 'Damages';
CONTENT_STRINGS.RECOVERABLE = 'Recoverable';
CONTENT_STRINGS.NAME = 'Name';
CONTENT_STRINGS.VERSION = 'Version';
CONTENT_STRINGS.NATURE_OF_EXPERT = 'Nature of Expert';
CONTENT_STRINGS.WHY_SPECIFIC_EXPERT = 'Why Specific Expert?';
CONTENT_STRINGS.BREACH_CAUSATION_CP = 'Breach/Causation/CP';
CONTENT_STRINGS.ESTIMATED_COST_OF_REPORT = 'Estimated Cost of Report';
CONTENT_STRINGS.ESTIMATED_COST_OF_ATTENDANCE = 'Estimated Cost of Attendance at Final Hearing';
CONTENT_STRINGS.CASE_STAGES = 'Case Stages';
CONTENT_STRINGS.SAVE_DAMAGE_BAND = 'Save Damage Band';
CONTENT_STRINGS.ADD_NEW_DAMAGE_BAND = 'Add New Damage Band';
CONTENT_STRINGS.DAMAGE_BANDS = 'Damage Bands';
CONTENT_STRINGS.DAMAGE_BAND = 'Damage Band';
CONTENT_STRINGS.TO = 'To';
CONTENT_STRINGS.ADD_TO_COMMISSION_LIST = 'Add To Commission List';
CONTENT_STRINGS.SAVE_CHANGES = 'Save changes';
CONTENT_STRINGS.CONFIRM = 'Confirm';
CONTENT_STRINGS.ADD_NON_CONTINGENT_PREMIUM = 'Add Non-Contingent Premium?';
CONTENT_STRINGS.CONTINGENT = 'Contingent';
CONTENT_STRINGS.NON_CONTINGENT = 'Non Contingent';
CONTENT_STRINGS.WRITEBACK = 'Writeback';
CONTENT_STRINGS.SAVE_DAMAGE_BAND = 'Save Damage Band';
CONTENT_STRINGS.ADD_NEW_DAMAGE_BAND = 'Add New Damage Band';
CONTENT_STRINGS.DAMAGE_BANDS = 'Damage Bands';
CONTENT_STRINGS.DAMAGE_BAND = 'Damage Band';
CONTENT_STRINGS.ADD_TO_COMMISSION_LIST = 'Add To Commission List';
CONTENT_STRINGS.COMMISSION_AGENT_ARAG_PROVIDER_MISMATCH =
    'This agent does not belong to the same ARAG Provider as the selected group and cannot be added.';
CONTENT_STRINGS.CREATE_NEW = 'Create New';
CONTENT_STRINGS.CREATE_NEW_BASED_ON_CURRENT = 'Create New Based On Current';
CONTENT_STRINGS.SHOW_ALL = 'Show all';
CONTENT_STRINGS.PREMIUM_SETTINGS = 'Premium Settings';
CONTENT_STRINGS.NONE = 'None';
CONTENT_STRINGS.UNLIMITED = 'Unlimited';
CONTENT_STRINGS.OVER = 'Over';
CONTENT_STRINGS.CUSTOM = 'Custom';
CONTENT_STRINGS.DEFAULT = 'Default';
CONTENT_STRINGS.PERCENTAGE = 'Percentage';
CONTENT_STRINGS.STAGED = 'Staged';
CONTENT_STRINGS.FLAT = 'Flat';
CONTENT_STRINGS.RATES = 'Rates';
CONTENT_STRINGS.VALUE = 'Value';
CONTENT_STRINGS.STAGE_OF_POLICY = 'Stage of Policy';
CONTENT_STRINGS.AMOUNTS = 'Amounts';
CONTENT_STRINGS.EDIT_STAGED_PREMIUM_SETTING = 'Edit Staged Premium Setting';
CONTENT_STRINGS.NEW_STAGED_PREMIUM_SETTING = 'New Staged Premium Setting';
CONTENT_STRINGS.BACK = 'Back';
CONTENT_STRINGS.COMMISSIONS = 'Commissions';
CONTENT_STRINGS.PREMIUMS_AND_LOI = 'Premiums & LOI';
CONTENT_STRINGS.NOTES_AND_COVERAGE = 'Notes & Coverage';
CONTENT_STRINGS.OVERVIEW = 'Overview';
CONTENT_STRINGS.STAGES = 'Stages';
CONTENT_STRINGS.DAMAGE_BANDS = 'Damage Bands';
CONTENT_STRINGS.PREMIUMS = 'Premiums';
CONTENT_STRINGS.LOI_AND_NOTES = 'LOI & Notes';
CONTENT_STRINGS.PRINT = 'Print';
CONTENT_STRINGS.DATE_CHANGED = 'Date Changed';
CONTENT_STRINGS.CHANGE_FROM = 'Changed From';
CONTENT_STRINGS.QUESTION = 'Question';
CONTENT_STRINGS.EDITABLE_BY = 'Editable By';
CONTENT_STRINGS.NEWS_AND_ARTICLES = 'News & Articles';
CONTENT_STRINGS.VIEW_ALL_ARTICLES = 'View All Articles';
CONTENT_STRINGS.SESSION_EXPIRES_IN = 'Session expires in: ';
CONTENT_STRINGS.NEW_APPLICATION = 'New Application';
CONTENT_STRINGS.APPLICATIONS_AND_POLICIES = 'Applications & Policies';
CONTENT_STRINGS.ADVANCE_DISBURSEMENTS = 'Advance Disbursements';
CONTENT_STRINGS.NOTIFICATIONS = 'Notifications';
CONTENT_STRINGS.MANAGE_ACCOUNT = 'Manage Account';
CONTENT_STRINGS.LOG_OFF = 'Log off';
CONTENT_STRINGS.PRIVACY_AND_COOKIES = 'Privacy & Cookies';
CONTENT_STRINGS.WEBSITE_TERMS_OF_USE = 'Website Terms of Use';
CONTENT_STRINGS.ARAG_USERS = 'ARAG Users';
CONTENT_STRINGS.AGENTS = 'Agents';
CONTENT_STRINGS.USERS = 'Users';
CONTENT_STRINGS.SETTINGS = 'Settings';
CONTENT_STRINGS.HOME = 'Home';
CONTENT_STRINGS.APPLICATION_FORM_REFERRAL_SETTINGS = 'Application form referral settings';
CONTENT_STRINGS.NEW_USER = 'New user';
CONTENT_STRINGS.APPLICATION_POLICY = 'Application/Policy';
CONTENT_STRINGS.EDIT_USER = 'Edit User';
CONTENT_STRINGS.NEW_PREMIUM_SETTINGS = 'New Premium Settings';
CONTENT_STRINGS.EDIT_PREMIUM_SETTINGS = 'Edit Premium Settings';
CONTENT_STRINGS.CREATE_NEW_ARTICLE = 'Create New Article';
CONTENT_STRINGS.ARTICLES = 'Articles';
CONTENT_STRINGS.EDIT_ARTICLES = 'Edit Articles';
CONTENT_STRINGS.CREATE_ADVANCE_DISBURSEMENT = 'Create advance disbursement';
CONTENT_STRINGS.INTERNAL_ALERTS = 'Internal Alerts';
CONTENT_STRINGS.NEW_INTERNAL_ALERT = 'New Internal Alert';
CONTENT_STRINGS.EDIT_INTERNAL_ALERT = 'Edit Internal Alert';
CONTENT_STRINGS.CREATE_NEW_INTERNAL_ALERT = 'Create new Internal Alert';
CONTENT_STRINGS.UPDATE_INTERNAL_ALERT = 'Update Internal Alert';
CONTENT_STRINGS.INTERNAL_ALERT = 'Internal Alert';
CONTENT_STRINGS.POLICY_LIVE_DATE_FROM = 'Policy Live Date From';
CONTENT_STRINGS.POLICY_LIVE_DATE_TO = 'Policy Live Date To';
CONTENT_STRINGS.CREATE_USER = 'Create User';
CONTENT_STRINGS.VIEW_USERS = 'View Users';
CONTENT_STRINGS.EDITING_SETTINGS = 'Editing Settings';
CONTENT_STRINGS.REFERRAL_SETTINGS = 'Referral Settings';
CONTENT_STRINGS.ADD_FILE = 'Add file...';
CONTENT_STRINGS.ADD_MORE_FILES = 'Add more files...';
CONTENT_STRINGS.PLEASE_REMOVE_DUPLICATE_FILES = 'Please remove duplicate files.';
CONTENT_STRINGS.LAST_UPDATE_DETAILS = 'The form below shows the details of your last update';
CONTENT_STRINGS.LAST_UPDATE_INSTRUCTIONS = 'Please provide details of any changes since then by updating your answers below.';
CONTENT_STRINGS.DRAG_AND_DROP = 'Drag and drop.';
CONTENT_STRINGS.LINKEDIN = 'LinkedIn';
CONTENT_STRINGS.X = 'X';
CONTENT_STRINGS.YOUTUBE = 'YouTube';
CONTENT_STRINGS.UPDATE = 'Update';
CONTENT_STRINGS.POLICY_UPDATE = 'Policy Update';
CONTENT_STRINGS.ATTACHMENT = 'Attachment(s)';
CONTENT_STRINGS.PREVIOUS_UPDATE_DETAILS = 'Previous Update Details';
CONTENT_STRINGS.ARAG_REFERENCE = 'ARAG Reference';
CONTENT_STRINGS.SUBMISSION_DATE = 'Submission Date';
CONTENT_STRINGS.APPLICATION_STATUS = 'Application Status';
CONTENT_STRINGS.CREATED_BY = 'Created by';
CONTENT_STRINGS.READ_BY_ARAG = 'Read by ARAG';
CONTENT_STRINGS.READ = 'Read';
CONTENT_STRINGS.UNREAD = 'Unread';
CONTENT_STRINGS.FIRM_AGENTS = 'Firm agents';
CONTENT_STRINGS.QUICK_SEARCH = 'Quick search';
CONTENT_STRINGS.STATUSES = 'Statuses';
CONTENT_STRINGS.CASE_TYPES = 'Case types';
CONTENT_STRINGS.SUB_CASE_TYPES = 'Sub case types';
CONTENT_STRINGS.SEARCH = 'Search';
CONTENT_STRINGS.SEARCHING = 'Searching...';
CONTENT_STRINGS.DISPLAY_DRAFT_APPLICATIONS = 'Display draft applications';
CONTENT_STRINGS.DETAILS = 'Details';
CONTENT_STRINGS.NO_APPLICATION_TO_SHOW = 'No application to show.';
CONTENT_STRINGS.APPLICATIONS_POLICIES_TITLE = 'Applications / Policies';
CONTENT_STRINGS.REFERRED_TO = ' to ';
CONTENT_STRINGS.DRAFT = 'Draft';
CONTENT_STRINGS.REFERENCE = 'Reference';
CONTENT_STRINGS.GROUP = 'Group';
CONTENT_STRINGS.FIRM = 'Firm';
CONTENT_STRINGS.ALL = 'All';
CONTENT_STRINGS.GLOBAL_POLICY_SEARCH = 'Global Policy Search';
CONTENT_STRINGS.NOTIFICATIONS_EMPTY_MESSAGE = 'No notification to show.';
CONTENT_STRINGS.NOTIFICATIONS = 'Notifications';
CONTENT_STRINGS.TAKE_ACTION = 'Take Action';
CONTENT_STRINGS.PREVIOUS_APPLICATION_PREMIUM_SETTING = 'Previous Application Premium Setting';
CONTENT_STRINGS.MARK_AS_VIEWED = 'Mark As Viewed';
CONTENT_STRINGS.CHANGE_STATUS = 'Change Status';
CONTENT_STRINGS.CHANGE_STATUS_TO = 'Change Status to';
CONTENT_STRINGS.COSTS_SUMMARY = 'Costs Summary';
CONTENT_STRINGS.TRANSFER_CASE = 'Transfer Case';
CONTENT_STRINGS.APPLY_PREMIUM_INDEMNITY_GUARANTEE = 'Apply Premium Indemnity Guarantee';
CONTENT_STRINGS.APPLY_PIG_CONFIRM_MESSAGE = 'By proceeding a Premium Indemnity Guarantee disbursement will be processed. Are you sure you want to proceed?';
CONTENT_STRINGS.PIG_APPLIED_EDIT_LOCKED_TOOLTIP = 'This cannot be edited because a Premium Indemnity Guarantee has been applied to this policy.';
CONTENT_STRINGS.VIEW_MORE = 'View more';
CONTENT_STRINGS.STATUS = 'Status';
CONTENT_STRINGS.REACTIVATION_DATE = 'Reactivation Date';
CONTENT_STRINGS.INCEPTION_DATE = 'Inception Date';
CONTENT_STRINGS.TERMINATION_DATE = 'Termination Date';
CONTENT_STRINGS.LAWSYS_CASE_REFERENCE = 'Lawsys Case Reference';
CONTENT_STRINGS.LAWSYS_CASE_DATE = 'Lawsys Case Date';
CONTENT_STRINGS.APPLICATION = 'Application';
CONTENT_STRINGS.DOCUMENTS = 'Documents';
CONTENT_STRINGS.PENDING_CHANGES = 'Pending Changes';
CONTENT_STRINGS.RENAME_DOCUMENT = 'Rename Document';
CONTENT_STRINGS.CURRENT_SETTINGS = 'Current Settings';
CONTENT_STRINGS.NEW_SETTINGS = 'New Settings';
CONTENT_STRINGS.SOLICITOR_FIRM = 'Solicitor Firm';
CONTENT_STRINGS.SOLICITOR_USER = 'Solicitor User';
CONTENT_STRINGS.TRANSFER_CONFIRM_MESSAGE = 'Are you sure you want to make the selected changes?';
CONTENT_STRINGS.NO_DISBURSEMENT_PAID = 'No disbursement was paid out';
CONTENT_STRINGS.DAMAGES_RECEIVED = 'Damages Received';
CONTENT_STRINGS.INSURANCE_PREMIUM_RECOVERABLE_FROM_OPPONENT = 'Insurance Premium recoverable from your opponent';
CONTENT_STRINGS.INSURANCE_PREMIUM_PAYABLE_FROM_DAMAGES = 'Insurance Premium payable from your damages';
CONTENT_STRINGS.STAGE = 'Stage';
CONTENT_STRINGS.DATE_CREATED = 'Date Created';
CONTENT_STRINGS.DATE_PAID = 'Date Paid';
CONTENT_STRINGS.PAYMENT_REFERENCE = 'Payment Reference';
CONTENT_STRINGS.DISBURSEMENT_TYPE = 'Disbursement Type';
CONTENT_STRINGS.AMOUNT = 'Amount';
CONTENT_STRINGS.SETTLED_AMOUNT = 'Settled Amount';
CONTENT_STRINGS.TAX_INCLUSIVE_RATE_MESSAGE = 'All Insurance Premiums stated are inclusive of Insurance Premium Tax at ';
CONTENT_STRINGS.CHANGE_STATUS_CONFIRM_MESSAGE = 'Are you sure you want to change the status to';
CONTENT_STRINGS.SEND_EMAIL_NOTIFICATION = 'Send email notification';
CONTENT_STRINGS.REFERRED_REASON = 'Referred Reason';
CONTENT_STRINGS.REJECTED_REASON = 'Rejected Reason';
CONTENT_STRINGS.REASON = 'Reason';
CONTENT_STRINGS.POLICY = 'Policy';
CONTENT_STRINGS.ARAG_PROVIDER = 'ARAG Provider';
CONTENT_STRINGS.VALID = 'Valid';
CONTENT_STRINGS.FROM = 'from';
CONTENT_STRINGS.UNTIL = 'until';
CONTENT_STRINGS.SELECT = 'Select';
CONTENT_STRINGS.USER_TO_SHOW = 'user to show';
CONTENT_STRINGS.GROUPS_TO_SHOW = 'group to show';
CONTENT_STRINGS.FINANCIALS = 'Financials';
CONTENT_STRINGS.CURRENT_PREMIUM_INFORMATION = 'Current Premium Information';
CONTENT_STRINGS.CURRENT_CASE_STAGE = 'Current Case Stage';
CONTENT_STRINGS.CURRENT_DAMAGES_RANGE = 'Current Damages Range (or Estimated Damages Range)';
CONTENT_STRINGS.CURRENT_LC_SPEND = 'Current L&C Spend (or Estimate)';
CONTENT_STRINGS.FINANCIAL_POSITION = 'Financial Position';
CONTENT_STRINGS.WHAT_WE_ARE_OWED = 'What We Are Owed';
CONTENT_STRINGS.PAYMENT_STATUS = 'Payment Status';
CONTENT_STRINGS.WHAT_WE_OWE = 'What We Owe';
CONTENT_STRINGS.SALES_TYPE = 'Sales Type';
CONTENT_STRINGS.TOTAL_SALES = 'Total Sales';
CONTENT_STRINGS.EXPENSES_TYPE = 'Expenses Type';
CONTENT_STRINGS.TOTAL_EXPENSES = 'Total Expenses';
CONTENT_STRINGS.UNPAID_AMOUNT = 'Unpaid Amount';
CONTENT_STRINGS.NOT_DUE = 'Not Due';
CONTENT_STRINGS.DUE_AND_PAID = 'Due & Paid';
// Deliberately its own key, not CONTENT_STRINGS.PAID - that name is already taken (below, the Advance
// Disbursement status label among APPROVED/PROCESSING/PART_SETTLED) and JS's last-assignment-wins would
// silently make this Financial Position column header track whatever that unrelated AD status is worded
// as, same coupling risk DUE_AND_PAID above was deliberately kept separate from CONTENT_STRINGS.AMOUNT for.
CONTENT_STRINGS.FINANCIAL_POSITION_PAID = 'Paid';
CONTENT_STRINGS.EXCL_ADVANCE_DISBURSEMENTS = '(excl. Advance Disbursements)';
CONTENT_STRINGS.AGENT_COMMISSION = 'Agent Commission';
CONTENT_STRINGS.TOTALS_GROSS_PREMIUM = 'Total/Gross Premium';
CONTENT_STRINGS.NET_PREMIUM = 'Net Premium';
CONTENT_STRINGS.FINANCIAL_POSITION_UNAVAILABLE = 'Unable to retrieve financial position from PLUTUS. Please try again later.';

// Filter texts
CONTENT_STRINGS.FILTER_BY_VISIBILITY = 'Filter by Visibility'
CONTENT_STRINGS.FILTER_INCLUDE_NO_CHANGES = 'Include No Changes Updates'
CONTENT_STRINGS.FILTER_LABEL = 'Filter';
CONTENT_STRINGS.CLEAR_FILTERS_LABEL = 'Clear Filters';
CONTENT_STRINGS.NO_RESULTS_FOUND = 'No results found';
CONTENT_STRINGS.SEARCH_FAILED = 'Search failed. Please try again.';
CONTENT_STRINGS.MIN_5_CHARACTERS_TO_SEARCH = 'Please type at least 5 characters to search';
CONTENT_STRINGS.NOTIFICATIONS_FILTER_STATUSES_LABEL = 'Filter by application statuses';
CONTENT_STRINGS.NOTIFICATIONS_FILTER_CASE_TYPES_LABEL = 'Filter by application case types';
CONTENT_STRINGS.NOTIFICATIONS_FILTER_NOTIFICATION_TYPE_LABEL = 'Filter by notifications type';
CONTENT_STRINGS.NOTIFICATIONS_FILTER_UPDATE_FORM_QUESTIONS_LABEL = 'Filter by update form questions';
CONTENT_STRINGS.DECLINED_REASON = 'Declined Reason';
CONTENT_STRINGS.REJECTED_REASON = 'Rejected Reason';
CONTENT_STRINGS.FILTER_BY = 'Filter by';

// Warning texts
CONTENT_STRINGS.MULTIPLE_PREMIUM_SETTINGS_FOUND = 'Multiple premium settings found. Please select the desired type and submit again';
CONTENT_STRINGS.DELETE_ITEM_TITLE = 'Are you sure you want to delete the selected item?';
CONTENT_STRINGS.FILE_REFERENCE_REQUIRED = 'File Reference field must be filled before saving.';
CONTENT_STRINGS.MEDICAL_EXPERT_FEES_TABLE_WARNING = 'Please, fill in all the medical expert fees table rows before submitting the application.';
CONTENT_STRINGS.PLEASE_ENTER_A_VALID_AMOUNT = 'Please enter a valid amount for';
CONTENT_STRINGS.SUM_OF_UNDERWRITER_RATE_AND_SOLICITOR_COMMISSION_RATE = 'Sum of underwriter rate and the solicitor\'s commission rate must not exceed the premium.';
CONTENT_STRINGS.VALID_FROM_DATE_CANNOT_BE_IN_THE_PAST = 'Valid from date cannot be in the past.';
CONTENT_STRINGS.VALID_UNTIL_DATE_CANNOT_BE_BEFORE_VALID_FROM_DATE = 'Valid until date cannot be before Valid from date.';
CONTENT_STRINGS.EMPTY_FIELDS = 'Please fill out this field.';
CONTENT_STRINGS.NEGATIVE_FIELDS = 'Value must be greater than or equal to 0.';
CONTENT_STRINGS.PLEASE_REMOVE_DUPLICATE_FILES_FOR_QUESTIONS = 'Please remove duplicate files for questions:';
CONTENT_STRINGS.DATE_INPUT_NOT_VALID = 'Date input is not valid.';
CONTENT_STRINGS.PLEASE_ENTER_VALID_AMOUNT_FOR = 'Please enter a valid amount for';
CONTENT_STRINGS.EMAIL_ADDRESS_NOT_VALID = 'Email address is not valid.';
CONTENT_STRINGS.AMOUNT_OF_FEE = 'Amount of fee';
CONTENT_STRINGS.FOUND = 'found';
CONTENT_STRINGS.FAILED_TO_LOAD_PREMIUM_SETTING = 'Could not load the premium setting. Please go back and try again.';

// Error texts
CONTENT_STRINGS.NAME_CANNOT_BE_EMPTY = 'Name cannot be empty.';
CONTENT_STRINGS.NO_ATTACHMENT_UPLOADED = 'No attachment uploaded.'
CONTENT_STRINGS.ACCEPT_LATEST = 'Please accept the latest ';
CONTENT_STRINGS.ACCEPT_LATEST_DESCRIPTION = 'in order to be able to create a new application';
CONTENT_STRINGS.TOBA = 'TOBA ';
CONTENT_STRINGS.NO_AGENTS_FOUND = 'No Agents found';
CONTENT_STRINGS.NO_APPLICATION_REFERRAL_SETTING = 'No application referral setting exists for the selected combination of case type and sub case type.';
CONTENT_STRINGS.STAGED_PREMIUMS_ERROR = 'Each Stage Premium & LOI cannot be less than the previous one';
CONTENT_STRINGS.STAGED_PREMIUMS_AMOUNT_ERROR = 'Please fill all the amount fields with values between $ 1 - $ 999,999,999';
CONTENT_STRINGS.RATES_REQUIRED = 'Rates are required';
CONTENT_STRINGS.STAGED_PREMIUMS_SUM_ERROR = "Sum of underwriter rate and the lawyer's commission rate must not exceed the premium.";
CONTENT_STRINGS.REQUIRED_FIELDS = 'Please fill all the required fields';
CONTENT_STRINGS.ERROR_SAVING_DATA = 'Error saving data. Please try again later.';
CONTENT_STRINGS.ERROR_VALID_DATE = 'Valid Until date cannot precede Valid From date.';
CONTENT_STRINGS.TYPE_AT_LEAST_5_CHARACTERS = 'Type at least 5 characters';
CONTENT_STRINGS.INVALID_DATE = 'Invalid Date';
CONTENT_STRINGS.TOO_MANY_DECIMALS = 'Value must not have more than 2 decimal places.';
CONTENT_STRINGS.AD_PROCESSING_CASE_RESULT_ERROR = 'The case result cannot be updated while an advance disbursement request is still processing.';
CONTENT_STRINGS.ERROR_LOADING_FINANCIALS = 'Error loading financials data. Please try again later.';


// Tooltip texts
CONTENT_STRINGS.UPLOAD_FILE_TOOLTIP = 'Try dropping some files here, or click to select files to upload.'
CONTENT_STRINGS.ADD_TAGS = 'Add Tags (separate with commas)';
CONTENT_STRINGS.CUSTOM_SETTINGS_REVERT = 'Custom settings will revert back to default settings AFTER selected valid until date';
CONTENT_STRINGS.FILES_UPLOADED_INFO = 'Files uploaded appear at the bottom of the application.';
CONTENT_STRINGS.GLOBAL_POLICY_SEARCH_INFO = 'Use the Global Policy Search field to find both current policies (yellow) and provide updates on legacy policies (black).';
CONTENT_STRINGS.GLOBAL_POLICY_SEARCH_PLACEHOLDER = 'Search by policy number, reference or client name';
CONTENT_STRINGS.AD_PROCESSING_UPDATE_FORM_BANNER = 'NB: The case result cannot be updated while an Advance Disbursement request is still processing.';

// TOBA form strings
CONTENT_STRINGS.CREATE = 'Create';
CONTENT_STRINGS.SELECTED = 'Selected';
CONTENT_STRINGS.GROUPS = 'Groups';
CONTENT_STRINGS.QUICK_SEARCH_FOR = 'Quick search for';
CONTENT_STRINGS.REVISIONS = 'Revisions';
CONTENT_STRINGS.REVISION = 'Revision';
CONTENT_STRINGS.ABOUT_TO_UPDATE_A = 'You are about to update a';
CONTENT_STRINGS.USERS_ACCEPTED_NOT_PROMPTED = 'Users who have accepted it will not be prompted to do so again.';
CONTENT_STRINGS.ABOUT_TO_CREATE_REVISION_OF = 'You are about to create a new revision of this';
CONTENT_STRINGS.AFFECTED = 'Affected';
CONTENT_STRINGS.USERS_ACCEPT_NEW = 'Users will have to accept the new';
CONTENT_STRINGS.REVISION_WHEN_LIVE = 'revision when this becomes live.';
CONTENT_STRINGS.ALL_REVISIONS_OF_THIS = 'All revisions of this';
CONTENT_STRINGS.STARTING_IN_FUTURE_ERASED = 'starting in the future will be erased.';
CONTENT_STRINGS.VERSION_NAME = 'Version Name';
CONTENT_STRINGS.CONTENT_LABEL = 'Content';
CONTENT_STRINGS.SAVE_AND_CREATE_NEW_REVISION = 'Save & Create New Revision';
CONTENT_STRINGS.SAVE_CURRENT_REVISION = 'Save Current Revision';
CONTENT_STRINGS.EDITING_NOW = 'EDITING NOW';
CONTENT_STRINGS.LIVE_VERSION = 'LIVE VERSION';
CONTENT_STRINGS.NAME_REQUIRED = 'Name is required.';
CONTENT_STRINGS.VERSION_REQUIRED = 'Version is required.';
CONTENT_STRINGS.VALID_FROM_DATE_REQUIRED = 'Valid from date is required.';
CONTENT_STRINGS.SELECT = 'Select';
CONTENT_STRINGS.VALID_FROM_DATE_INVALID = 'Valid from date input is invalid. Date format is: DD/MM/YYYY.';
CONTENT_STRINGS.REVISIONS_LOADING = 'revisions are loading. Please wait.';
CONTENT_STRINGS.TO_CONTINUE = 'to continue.';
CONTENT_STRINGS.CONTENT_MUST_NOT_BE_EMPTY = 'Content must not be empty.';

CONTENT_STRINGS.LAWSYS_ID = 'LawsysID';
CONTENT_STRINGS.USER_NAME = 'User Name';
CONTENT_STRINGS.ACTIVE = 'Active';
CONTENT_STRINGS.INACTIVE = 'Inactive';
CONTENT_STRINGS.ENABLE_USERS = 'Enable User(s)';
CONTENT_STRINGS.DISABLE_USERS = 'Disable User(s)';
CONTENT_STRINGS.NEW = 'New';
CONTENT_STRINGS.CHANGE = 'Change';
CONTENT_STRINGS.CREATE = 'Create';
CONTENT_STRINGS.USER = 'User';
CONTENT_STRINGS.ATE = 'ATE';
CONTENT_STRINGS.CHANGE_SOLICITOR = 'Change Solicitor';
CONTENT_STRINGS.EXISTING = 'Existing';
CONTENT_STRINGS.CONFIRM_CHANGES = 'Confirm changes?';
CONTENT_STRINGS.CAPACITY_UNDERWRITER = 'Capacity Underwriter';
CONTENT_STRINGS.WORK_SOURCES = 'Work Sources';

// Advance Disbursements list
CONTENT_STRINGS.POLICY_STATUS = 'Policy Status';
CONTENT_STRINGS.DOWNLOAD_STATEMENT = 'Download Statement';
CONTENT_STRINGS.DOWNLOAD_STATEMENT_TOOLTIP_PREFIX = 'Select an individual';
CONTENT_STRINGS.DOWNLOAD_STATEMENT_TOOLTIP_SUFFIX = 'firm in order to print a statement';
CONTENT_STRINGS.DOWNLOAD_STATEMENT_DISABLED_SOLICITOR_TOOLTIP = 'This functionality is currently disabled. Please contact ARAG if you require an Advance Disbursement Statement.';
CONTENT_STRINGS.POLICY_NUMBER = 'Policy Number';
CONTENT_STRINGS.AMOUNT_FROM = 'Amount From';
CONTENT_STRINGS.FIRMS = 'Firms';
CONTENT_STRINGS.APPLIED = 'Applied';
CONTENT_STRINGS.REJECTED = 'Rejected';
CONTENT_STRINGS.APPROVED = 'Approved';
CONTENT_STRINGS.PROCESSING = 'Processing';
CONTENT_STRINGS.PAID = 'Paid';
CONTENT_STRINGS.PART_SETTLED = 'Part Settled';
CONTENT_STRINGS.SETTLED = 'Settled';
CONTENT_STRINGS.TOTAL = 'Total';
CONTENT_STRINGS.NUMBER_OF_ADVANCE_DISBURSEMENTS_PER_STATUS = 'Number of Advance Disbursements per status';
CONTENT_STRINGS.TOTAL_AMOUNT_OF_ADVANCE_DISBURSEMENTS_PER_STATUS = 'Total amount of Advance Disbursements per status';

//Tobas
CONTENT_STRINGS.DELETE_TOBA_CONFIRMATION_PREFIX = 'You are about to';
CONTENT_STRINGS.DELETE_TOBA_CONFIRMATION_SUFFIX = "the following";
CONTENT_STRINGS.VIEW_SOLICITOR_GROUPS_LINK_TEXT = 'View Solicitor Groups attached to this';
CONTENT_STRINGS.EXPIRY_DATE = 'Expiry date';
CONTENT_STRINGS.FILES_ATTACHED = 'Files Attached';
CONTENT_STRINGS.POPULATE_EDIT_FORM_FROM_REVISION = 'Populate edit form from this';
// Must stay byte-for-byte identical to GroupsService.AragProviderMismatchMessage - the API returns
// that one when the same check runs server side, and the user has to see one single wording.
CONTENT_STRINGS.ARAG_PROVIDER_MISMATCH = 'The selected Solicitor Firms and Underwriter belong to different ARAG Providers. ' +
    'All selected entities must belong to the same ARAG Provider before the Solicitor Group can be created.';

export default CONTENT_STRINGS;